var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MPButton',{staticClass:"f-button",attrs:{"color":"fb","size":"large"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('i',{staticClass:"icon"}),_vm._v(_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }